import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Paper,
    Grid,
    Card,
    CardContent,
    Chip
} from '@mui/material';
import { useApiHandler } from '../../hooks/useApiHandler';
import DashboardLayout from '../../components/layouts/DashboardLayout';
import ProductList from './products/ProductList';
import { productService } from '../../services/productService';

function ProductManagement() {
    const [stats, setStats] = useState(null);
    const { showSuccess, showError } = useApiHandler();

    useEffect(() => {
        loadProductStats();
    }, []);

    const loadProductStats = async () => {
        try {
            const response = await productService.getProductStats();
            if (response.success) {
                setStats(response.data);
            }
        } catch (error) {
            console.error('Error loading statistics:', error);
            showError('Error loading product statistics');
        }
    };

    return (
        <DashboardLayout>
            {/* Header */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Product Management
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Manage courier products and their rate configurations
                </Typography>
            </Box>

            {/* Statistics Cards */}
            {stats && (
                <Grid container spacing={3} sx={{ mb: 4 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card>
                            <CardContent>
                                <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                                    Total Products
                                </Typography>
                                <Typography variant="h3" color="primary">
                                    {stats.total_products}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card>
                            <CardContent>
                                <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                                    Document Products
                                </Typography>
                                <Typography variant="h3" color="success.main">
                                    {stats.document_products}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card>
                            <CardContent>
                                <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                                    Non-Document Products
                                </Typography>
                                <Typography variant="h3" color="warning.main">
                                    {stats.non_document_products}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card>
                            <CardContent>
                                <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                                    Products with Rates
                                </Typography>
                                <Typography variant="h3" color="info.main">
                                    {stats.products_with_rates}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}

            {/* Product List */}
            <Paper sx={{ width: '100%', p: 0 }}>
                <ProductList onDataChange={loadProductStats} />
            </Paper>
        </DashboardLayout>
    );
}

export default ProductManagement; 